var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 2307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_6979)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4399.5,
    y: -2265.5,
    width: 8999,
    height: 5999,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 734.004,
    r: 299.5,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 734.004,
    r: 479.5,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 734.004,
    r: 767.5,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 733.804,
    r: 1228.3,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.08,
    cy: 734.08,
    r: 1965.58,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.728,
    cy: 733.732,
    r: 3145.23,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.853,
    cy: 733.853,
    r: 4529.35,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4400,
    y1: 733.504,
    x2: 4600,
    y2: 733.504,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4400.14,
    y1: 2094.53,
    x2: 4599.85,
    y2: -627.479,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 9402.62,
    y2: -0.5,
    transform: "matrix(0.95718 0.289495 0.289495 -0.95718 -4400 -626.998)",
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.5,
    y1: 3734,
    x2: 99.5,
    y2: -2266,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1919.57,
    y1: 3734.26,
    x2: -1720.43,
    y2: -2265.74,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7017.81,
    y2: -0.5,
    transform: "matrix(0.51868 -0.854968 -0.854968 -0.51868 -1720 3734)",
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2900,
    y1: 733.504,
    x2: 3100,
    y2: 733.504,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4400.28,
    y1: 3733.58,
    x2: 4599.72,
    y2: -2266.42,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4400.28,
    y1: 3733.58,
    x2: 4599.72,
    y2: -2266.42,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 10816.7,
    y2: -0.5,
    transform: "matrix(-0.83205 -0.5547 -0.5547 0.83205 4600 3734)",
    stroke: "black",
    strokeOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_6979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9000,
    height: 6000,
    fill: "white",
    transform: "translate(-4400 -2266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkLaptop);
export default __webpack_public_path__ + "static/media/watermark-laptop.440957fbd6be9a72a2287db04d478853.svg";
export { ForwardRef as ReactComponent };